export enum SpecialNeedEnum {
  NORMAL = 'Normal',
  HANDICAPPED = 'Handicap',
  PRIORITY = 'Priority',
  LUGGAGE = 'Empty car',
  SERVICE = 'Space allocation',
}
